import React from "react";
import PropTypes from "prop-types";

import {
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  TextField
} from "@material-ui/core";

import { Row, Col } from "react-flexbox-grid";

const DetailsModal = props => {
  const formHasIssues = props.modalData.process_error;
  const formHasLog = props.modalData.process_log;

  const styles = {
    tableFont: {
      fontFamily: "Roboto"
    }
  };

  let errorDiv = <div />;
  if (formHasIssues) {
    errorDiv = (
      <div style={styles.tableFont}>
        <TextField
          fullWidth
          id="outlined-multiline-flexible"
          label="Error Report"
          multiline
          variant="outlined"
          rows={25}
          value={props.modalData.process_error}
        />
      </div>
    );
  } else {
    errorDiv = (
      <DialogContentText>
        <b>Submission has no errors/warnings.</b>
      </DialogContentText>
    );
  }

  let logDiv = <div />;
  if (formHasLog) {
    logDiv = (
      <div style={styles.tableFont}>
        <TextField
          fullWidth
          id="outlined-multiline-flexible"
          label="Process Log"
          multiline
          variant="outlined"
          rows={25}
          value={props.modalData.process_log}
        />
      </div>
    );
  } else {
    logDiv = (
      <DialogContentText>
        <b>Submission does not have a process log yet.</b>
      </DialogContentText>
    );
  }

  return (
    <Dialog
      fullWidth
      maxWidth={false}
      modal="true"
      open={props.detailsModalOpen}
      onClose={props.onDetailsModalClose}
      scroll="body"
    >
      <DialogTitle>
        <Row>
          <Col xs={12}>{props.modalData.hakai_id}</Col>
        </Row>
      </DialogTitle>
      <DialogContent>
        <div style={{ padding: 20 }}>
          <Row>
            <Col xs={12}>{errorDiv}</Col>
          </Row>
        </div>
        <div style={{ padding: 20 }}>
          <Row>
            <Col xs={12}>{logDiv}</Col>
          </Row>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          color="primary"
          onClick={props.onDetailsModalClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DetailsModal.defaultProps = {
  detailsModalOpen: false
};

DetailsModal.propTypes = {
  detailsModalOpen: PropTypes.bool,
  onDetailsModalClose: PropTypes.func.isRequired,
  modalData: PropTypes.shape({
    hakai_id: PropTypes.string,
    process_error: PropTypes.string,
    process_log: PropTypes.string
  }).isRequired
};

export default DetailsModal;
